import { callActionWithId } from './helpers'

export const updateUserLanguage = callActionWithId('/me/language/{languageIsoCode}', 'post')
